import {Serializer} from '../interfaces/serializer';
import {DataSourceProvider} from '../store/dataSourceProviders/dataSourceProviders';

export type DataSourceProviderComponentObjects = Array<DataSourceProviderComponentObject>;

export class DataSourceProviderComponentObject {
  public payload: Serializer<DataSourceProvider>

  constructor(
    payload: Serializer<DataSourceProvider>
  ) {
    this.update(payload);
  }

  public update(payload: Serializer<DataSourceProvider>): void {
    this.payload = payload;
  }

}
